import { Link } from 'react-router-dom'
import LogoMark from './LogoMark'

export default function Footer() {
  return (
    <footer className="ftr" id="about">
      <div className="wrap">
        <div className="ftr-top">
          <div className="fbrand">
            <LogoMark />
            <p>A living manual for real self-reliance. Calm, competent, current, published every other day.</p>
          </div>
          <div className="fcol">
            <h4>Explore</h4>
            <a href="/#start">Start Here</a>
            <a href="/#guides">Guides</a>
            <Link to="/articles">Articles</Link>
          </div>
          <div className="fcol">
            <h4>Pillars</h4>
            {/* No dedicated per-pillar hub pages yet — point at the real archive
                rather than a dead "#". See Pillars.tsx for the same call. */}
            <Link to="/articles">Food &amp; Water</Link>
            <Link to="/articles">Home &amp; Power</Link>
            <Link to="/articles">Skills</Link>
            <Link to="/articles">Community</Link>
          </div>
          <div className="fcol">
            <h4>Brand</h4>
            <a href="/#about">About</a>
            <a href="/#newsletter">Free Starter Kit</a>
            <a href="mailto:contact@originalsavage.com">Contact</a>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
        </div>
        <div className="ftr-bot">
          <div className="meta">
            <span>&copy; 2026 Original Savage</span>
            <span>originalsavage.com</span>
            <span className="g">SYS: OPERATIONAL</span>
          </div>
          <div className="meta">
            <span>Educational content only. Not medical, legal, or financial advice.</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
